const ACTIVE_SENSORS_URL = process.env.API_URL + '/xugarhero/sensor/user';

const activeSensor = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ACTIVE_SENSORS_URL).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default{
  activeSensor
};



// WEBPACK FOOTER //
// ./src/brand/health/api/activeSensorUsers/index.js